import { useQuery } from "@tanstack/react-query";
import { CLIENT_API } from "../services/client.request";
import i18next from "i18next";

const useGetAllData = <T = any>({
  queryKey,
  url,
  options,
  urlParams,
}: {
  queryKey: any[];
  url: string;
  options?: any;
  urlParams?: Record<string, any>;
}) => {
  return useQuery<T>({
    queryKey: [...queryKey, i18next.language],
    queryFn: () =>
      CLIENT_API.getAll({ url, _params: urlParams }),
    ...options,
  });
};

export default useGetAllData;
